import Environment from '@di-shared/features/environment/Environment';
import Kr from '@di-shared/features/history/driving-info/DrivingInfoHeaderSettingTooltip/.kr';

export interface DrivingInfoHeaderSettingTooltipProps {
  vin: string;
}

export default function DrivingInfoHeaderSettingTooltip({vin}: DrivingInfoHeaderSettingTooltipProps) {
  return (
    <>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
    </>
  );
}
